import * as z from "zod";

export const deleteAutomationOutreachSplit = {
  name: "deleteAutomationOutreachSplit" as const,
  input: z.object({ splitId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
